import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f34de0ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clubCaptains" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "center display-2 mb-4" }, "Klubmedlemmer", -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "layout gutter--lg" }
const _hoisted_5 = { class: "row justify--center align--center" }
const _hoisted_6 = {
  class: "md6 flex",
  style: {"display":"flex"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_8 = { class: "va-table-responsive" }
const _hoisted_9 = {
  class: "va-table va-table--striped clubCaptainTable",
  style: {"width":"100%"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", null, "Licensnummber"),
    /*#__PURE__*/_createElementVNode("th", null, "Telefon"),
    /*#__PURE__*/_createElementVNode("th", null, "Email")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.memberSearchInputValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.memberSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.findMember()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.findMember()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_component_it_divider),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clubMembers, (member) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: member.id
              }, [
                _createElementVNode("td", null, [
                  _createVNode(_component_router_link, {
                    to: { name: 'Memberinfo', params: { slug: _ctx.generateUserSlug(member.id, member.user_id.firstname, member.user_id.lastname)}}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(member.user_id.firstname + ' ' + member.user_id.lastname), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", null, _toDisplayString(member.medlem_licens), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.showPhoneNumber(member.id)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.showEmail(member.id)), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}